export default {
  analytics: {
    id: process.env.REACT_APP_GOOGLE_ANALYTICS_ID || '',
  },
};
